import React from "react"
import classNames from "classnames"
import { Icon } from "../Icon"

export interface BulletListProps {
  children: React.ReactNode
  iconPosition?: "top" | "centered"
}

export const BulletList = ({
  children,
  iconPosition = "centered",
}: BulletListProps) => (
  <ul
    className={classNames("cobalt-BulletList", {
      "cobalt-BulletList--iconPositionTop": iconPosition === "top",
    })}
  >
    {children}
  </ul>
)

interface BulletListItemProps {
  children: React.ReactNode
  icon: ReturnType<typeof Icon>
}

export const BulletListItem = ({ children, icon }: BulletListItemProps) => (
  <li className="cobalt-BulletListItem">
    <span className="cobalt-BulletListItem__Icon">{icon}</span>
    <p className="cobalt-BulletListItem__Content">{children}</p>
  </li>
)
